import React, { useEffect, useRef } from 'react'
import $ from 'jquery'

const flattenTooltipTitle = (value) => {
  if (value == null || typeof value === 'boolean') return ''
  if (typeof value === 'string' || typeof value === 'number') return String(value)
  if (typeof value === 'function') return value
  if (Array.isArray(value)) return value.map(flattenTooltipTitle).join('')
  if (React.isValidElement(value)) {
    if (value.type === 'br') return '<br />'
    return flattenTooltipTitle(value.props?.children)
  }
  return ''
}

const TooltipComponent = ({children, title, tooltipContent, placement = 'top', trigger = 'hover focus', container = 'body', className = '', ...props}) => {
  const tooltipRef = useRef(null)
  const tooltipTitle = flattenTooltipTitle(title ?? tooltipContent)
  const displayTitle = typeof tooltipTitle === 'string' ? tooltipTitle : ''

  useEffect(() => {
    const element = tooltipRef.current
    if (!element) return

    $(element).tooltip('dispose')
    $(element).tooltip({ title: displayTitle, placement, trigger, container, html: true, boundary: 'window',})

    return () => {$(element).tooltip('dispose')}}, [displayTitle, placement, trigger, container])

  return (
    <span ref={tooltipRef} className={className} data-toggle="tooltip" data-placement={placement} title={displayTitle} {...props}>{children}</span>
  )
}

export default TooltipComponent
